import { StoryLevelData } from "@/app/lib/levels/story-level-data-types";
import { parseBuilderText } from "@/app/builder/build-parser";

const builderText =
`"alphabet soups"
pEa
mIso
TomaTo
#pmsoa

pho
gAzpACho
#zophg

woNtoN
boRScHt
cHowDER
#owbtc

rAmen
LentIL
mIneStrOne
#metnr`

const id = 'soup-0.0'

const parsed = parseBuilderText(builderText, id);

if (parsed.levelData === null) {
    throw new Error(`Invalid builder text for ${id}`);
}

export const soup: StoryLevelData = parsed.levelData;